import Loader from "./Loader.vue"
import Stepper from "./Stepper.vue"

export default {
    install(Vue) {
        Vue.component(Loader.name, Loader)
        Vue.component(Stepper.name, Stepper)
    },
}
